/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SlackDirectoryMember,
  SlackDirectoryMember$inboundSchema,
} from "./slackdirectorymember.js";

/**
 * Freshness of the workspace snapshot, independent of mapping state.
 */
export const SlackPersonAccountDirectoryStatus = {
  NeverSynced: "never_synced",
  Current: "current",
  Stale: "stale",
} as const;
/**
 * Freshness of the workspace snapshot, independent of mapping state.
 */
export type SlackPersonAccountDirectoryStatus = ClosedEnum<
  typeof SlackPersonAccountDirectoryStatus
>;

/**
 * An existing admin-confirmed workspace membership for one active organization person. Read-only and grants no permissions. The shared member view includes revision and evidence fields; using them to change a mapping still requires organization administration.
 */
export type SlackPersonAccount = {
  /**
   * Freshness of the workspace snapshot, independent of mapping state.
   */
  directoryStatus: SlackPersonAccountDirectoryStatus;
  /**
   * Last complete directory publication, possibly from an earlier authorization.
   */
  lastFullSyncSucceededAt?: Date | undefined;
  member: SlackDirectoryMember;
};

/** @internal */
export const SlackPersonAccountDirectoryStatus$inboundSchema: z.ZodMiniEnum<
  typeof SlackPersonAccountDirectoryStatus
> = z.enum(SlackPersonAccountDirectoryStatus);

/** @internal */
export const SlackPersonAccount$inboundSchema: z.ZodMiniType<
  SlackPersonAccount,
  unknown
> = z.pipe(
  z.object({
    directory_status: SlackPersonAccountDirectoryStatus$inboundSchema,
    last_full_sync_succeeded_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    member: SlackDirectoryMember$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "directory_status": "directoryStatus",
      "last_full_sync_succeeded_at": "lastFullSyncSucceededAt",
    });
  }),
);

export function slackPersonAccountFromJSON(
  jsonString: string,
): SafeParseResult<SlackPersonAccount, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SlackPersonAccount$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SlackPersonAccount' from JSON`,
  );
}
